import React, { Fragment } from "react";

export default function WrapperContainer(props) {
  return props.enabled ? (
    <props.wrapper>{props.children}</props.wrapper>
  ) : (
    <Fragment>{props.children}</Fragment>
  );
}
